export default __webpack_public_path__ + "static/sz_hu_4-a391b5e45977872d133a28a68ab8c9b0.mp4";